import { IssuePieChartByAssigneeReportResult } from '@tap/data-providers';
import { PeriodSelectType, PeriodSelectTypeSpec, Widget } from '@tap/mui-ui';
import { ChartCustom, CustomChartTooltip } from '@tap/tap-ui';
import { Tooltip as RechartsTooltip, PieChart, Pie, Cell, Legend } from 'recharts';

/* График Круговая диаграмма по исполнителям для заявок
*/

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#AF19FF'];

type IssuePieChartByAssigneeProps = {
    reportData: IssuePieChartByAssigneeReportResult[],
    periodType: PeriodSelectType,
}

const getColor = (index: number, arrayLength: number) => {
    if (arrayLength - 1 === index && COLORS[index] === COLORS[0])
        return COLORS[1];

    return COLORS[index % 5];
}

export default function IssuePieChartByAssignee({ reportData, periodType }: IssuePieChartByAssigneeProps) {

    return (
        <Widget title={`Круговая диаграмма показывает количество незавершённых заявок и заявок, завершённых за последние ${PeriodSelectTypeSpec[periodType].daysQuantity} дней`}>
            <ChartCustom>
                <PieChart width={730} height={300}>
                    <Pie data={reportData}
                        color="#000000"
                        dataKey="issueCount"
                        nameKey="assigneeName"
                        cx="50%"
                        cy="50%"
                        outerRadius={130}
                        fill="#8884d8"
                    >
                        {
                            reportData.map((entry, index, array) => <Cell key={`cell-${index}`} fill={getColor(index, array.length)} />)
                        }
                    </Pie>
                    <Legend />
                    <RechartsTooltip
                        wrapperStyle={{ outline: 'none' }}
                        content={
                            <CustomChartTooltip
                                labelTemplate={(label) => {
                                    return label;
                                }}
                                valueTemplate={payload =>
                                    <>{payload.name}: {payload.value}</>
                                }
                            />
                        }
                    />
                </PieChart>
            </ChartCustom>
        </Widget>
    );
}

